import { useMutation } from "react-query";
import http from "infra/http";

function useExcluirExtrato() {
  return useMutation(
    (extratoId: string) => {
      return http.delete(`/v1/extrato-bancario/${extratoId}`);
    },
    { retry: false }
  );
}

export default useExcluirExtrato;
